module.exports = __webpack_public_path__ + "img/nursery1.f32d4f61.jpg";